import { render, staticRenderFns } from "./addExpress.vue?vue&type=template&id=33647deb&scoped=true&"
import script from "./addExpress.vue?vue&type=script&lang=js&"
export * from "./addExpress.vue?vue&type=script&lang=js&"
import style0 from "./addExpress.vue?vue&type=style&index=0&id=33647deb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33647deb",
  null
  
)

export default component.exports